export default function SFWarningIcon({}) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="40" cy="40" r="40" fill="#FAFAFA" />
      <rect x="36" y="21" width="8" height="28" rx="4" fill="#C1C1C1" />
      <rect x="36" y="53" width="8" height="8" rx="4" fill="#C1C1C1" />
    </svg>
  );
}
